/**
 * Conteúdo completo de Termos de Uso + Política de Privacidade.
 * Usado no modal de aceite e nas páginas /termos e /privacidade.
 */
export function TermosConteudoCompleto() {
  return (
    <div className="prose prose-sm max-w-none dark:prose-invert space-y-6 text-left">
      {/* === TERMOS DE USO === */}
      <div>
        <h2 className="text-lg font-semibold mb-3">Termos de Uso – Sun7 Link</h2>
        <p className="text-xs text-muted-foreground mb-4">Última atualização: 20 de fevereiro de 2025</p>

        <section className="mb-6">
          <h3 className="text-base font-semibold mb-2">1. Identificação</h3>
          <p>
            <strong>RST SERVIÇÕES DE ENGENHARIA LTDA</strong><br />
            CNPJ: 37.395.997/0001-36<br />
            Endereço: R. Belmira Isabel Martins, 42 - Estreito, Florianópolis - SC, 88075-145
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-base font-semibold mb-2">2. Objetivo e Descrição da Plataforma</h3>
          <p>
            O <strong>Sun7 Link</strong> é uma plataforma de indicações remuneradas para sistemas fotovoltaicos e instalações de carregadores veiculares. Nossos parceiros possuem a possibilidade de obter renda extra com indicações de clientes interessados em soluções de energia solar e mobilidade elétrica.
          </p>
          <p>
            A plataforma serve tanto para o <strong>público interno</strong> (funcionários, vendedores e administradores), que realizam suas tarefas em um único local de forma integrada, quanto para <strong>parceiros externos</strong> (não funcionários), que realizam indicações e acompanham comissões a receber, saldos e status de propostas e contratos.
          </p>
          <p className="font-medium mt-2">Funcionalidades para Parceiros:</p>
          <ul className="list-disc pl-6 space-y-1 text-sm">
            <li>Dashboard, CRM, Clientes, Calculadoras, Carregadores Veiculares</li>
            <li>Dimensionamento, Propostas FV, Contratos FV, Tarefas</li>
            <li>Parceiros (sub-parceiros quando autorizado), Comissões</li>
          </ul>
          <p className="font-medium mt-2">Funcionalidades para Vendedores:</p>
          <ul className="list-disc pl-6 space-y-1 text-sm">
            <li>Ferramentas operacionais integradas, gestão de distribuidores</li>
            <li>Metas, territórios, área financeira e relatórios (conforme permissão)</li>
          </ul>
        </section>

        <section className="mb-6">
          <h3 className="text-base font-semibold mb-2">3. Aceitação dos Termos</h3>
          <p>
            Ao utilizar o Sun7 Link, você declara ter lido, compreendido e aceito integralmente estes Termos de Uso e a Política de Privacidade. O acesso e uso da plataforma ficam condicionados à aceitação prévia dos referidos documentos.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-base font-semibold mb-2">4. Condições de Acesso</h3>
          <p>
            O acesso é concedido mediante cadastro, aprovação e credenciais de login. Parceiros e vendedores devem utilizar credenciais pessoais e intransferíveis. É proibido compartilhar usuário e senha.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-base font-semibold mb-2">5. Obrigações do Usuário</h3>
          <ul className="list-disc pl-6 space-y-1 text-sm">
            <li>Manter dados cadastrais atualizados e verídicos</li>
            <li>Responsabilizar-se pela confidencialidade da senha</li>
            <li>Utilizar a plataforma apenas para fins legítimos</li>
            <li>Não realizar práticas fraudulentas ou abusivas</li>
          </ul>
        </section>

        <section className="mb-6">
          <h3 className="text-base font-semibold mb-2">6. Propriedade Intelectual e Limitações</h3>
          <p>
            O Sun7 Link é de propriedade da RST SERVIÇÕES DE ENGENHARIA LTDA. A empresa não se responsabiliza por danos indiretos ou falhas decorrentes de caso fortuito, força maior ou uso indevido.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-base font-semibold mb-2">7. Foro</h3>
          <p>
            Fica eleito o foro da Comarca de Florianópolis/SC para dirimir quaisquer controvérsias.
          </p>
        </section>

        {/* === POLÍTICA DE PRIVACIDADE === */}
        <hr className="my-8 border-border" />
        <h2 className="text-lg font-semibold mb-3">Política de Privacidade – Sun7 Link</h2>
        <p className="text-xs text-muted-foreground mb-4">Última atualização: 20 de fevereiro de 2025</p>

        <section className="mb-6">
          <h3 className="text-base font-semibold mb-2">1. Controlador</h3>
          <p>
            RST SERVIÇÕES DE ENGENHARIA LTDA, CNPJ 37.395.997/0001-36, R. Belmira Isabel Martins, 42 - Estreito, Florianópolis - SC, 88075-145.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-base font-semibold mb-2">2. Dados Coletados</h3>
          <p>
            Coletamos nome, e-mail, telefone, CPF, endereço e dados necessários ao cadastro e operação. Para leads/clientes: dados para propostas, contratos e instalações. Dados de uso para segurança e melhoria.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-base font-semibold mb-2">3. Finalidade e Base Legal</h3>
          <p>
            Tratamento para cadastro, gestão de contas, leads, propostas, contratos, comissões, cumprimento legal e segurança. Base: consentimento, execução de contrato, legítimo interesse e obrigação legal (LGPD).
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-base font-semibold mb-2">4. Compartilhamento e Retenção</h3>
          <p>
            Dados podem ser compartilhados com prestadores indispensáveis e órgãos públicos quando exigido. Não comercializamos dados. Retenção pelo tempo necessário; eliminação ou anonimização posterior.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-base font-semibold mb-2">5. Direitos do Titular (LGPD Art. 18)</h3>
          <p>
            Você pode solicitar confirmação de tratamento, acesso, correção, anonimização, portabilidade e revogação do consentimento. Entre em contato pelo endereço indicado.
          </p>
        </section>

        <section className="mb-6">
          <h3 className="text-base font-semibold mb-2">6. Segurança e Contato</h3>
          <p>
            Adotamos medidas técnicas e organizacionais para proteger os dados. Dúvidas: R. Belmira Isabel Martins, 42 - Estreito, Florianópolis - SC, 88075-145.
          </p>
        </section>

        <div className="pt-4 border-t">
          <p className="text-sm text-muted-foreground">
            Em conformidade com a LGPD (Lei nº 13.709/2018) e o Marco Civil da Internet.
          </p>
        </div>
      </div>
    </div>
  );
}
